import styled from 'styled-components';

export const Container = styled.div`
  background-color: #cecece;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  img {
    margin-bottom: 10px;
    margin-left: 29px;
  }
`;

export default Container;
